// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodepenCircleFilledSvg from "@fishx/icons-svg/es/asn/CodepenCircleFilled";
import FishxIcon from '../components/FishxIcon';

var CodepenCircleFilled = function CodepenCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CodepenCircleFilledSvg
  }));
};

CodepenCircleFilled.displayName = 'CodepenCircleFilled';
export default React.forwardRef(CodepenCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CodepenCircleFilled.js
// module id = 2273
// module chunks = 0